import * as React from "react"
import styled from "styled-components"

import Box from "../../lib/ui/ui-box"
import NavBar from "../../components/navigation"
import LandingContent from "../../components/landing"

const HomeWrapper = styled(Box)`
  min-height: 100vh;
  background: #f3f3f1;
  flex-direction: column;
  margin: 0 auto;
`

interface Props {
  language: any
}
class Home extends React.Component<Props> {
  render() {
    return (
      <HomeWrapper>
        <NavBar />
        <LandingContent />
      </HomeWrapper>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/containers/home/home.container.tsx